export const TEST_ID = 'buttonSubtext';
